import { clientAxios } from '../../../lib/axios';

export const getServerDetails = () => {
  return clientAxios.get('get_serverdetails');
};
